import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: 'replaceNewLines'})
export class ReplaceNewLinePipe implements PipeTransform {
  transform(value: string): string {
    return value? value.replace(/\n/g, "<br>") : value;
  }
}
